export default __webpack_public_path__ + "static/media/desk-lamp.9389deb5.png";